import { Component, OnInit } from '@angular/core';
import { PortalProfileService } from './portal-profile.service';
import { PortalProfileModel } from './portal-profile.models';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portal-profile',
  templateUrl: './portal-profile.component.html',
  styleUrls: ['./portal-profile.component.scss'],
})
export class PortalProfileComponent implements OnInit {
  profile: PortalProfileModel;
  loading = true;

  constructor(
    private portalProfileService: PortalProfileService,
    private appConfigService: AppConfigService,
    private router: Router
  ) {}
  ngOnInit(): void {
    if (
      this.appConfigService.tenant.portalConfiguration &&
      this.appConfigService.tenant.portalConfiguration.showProfileTab !== true
    ) {
      this.router.navigate(['portal/not-found'], {
        skipLocationChange: true,
      });
    }
    this.loadProfile();
  }

  get hasAddress(): boolean {
    if (!this.profile) return false;
    return !!(
      this.profile.streetAddress1 ||
      this.profile.streetAddress2 ||
      this.profile.city ||
      this.profile.postalCode ||
      this.profile.countryId ||
      this.profile.stateId ||
      this.profile.region
    );
  }

  get isPortalValidateAddress(): boolean {
    return this.appConfigService.tenant.portalConfiguration?.validateProfileAddress;
  }

  private loadProfile(): void {
    this.portalProfileService
      .getProfile()
      .then((profile) => {
        this.profile = profile;
        this.loading = false;
      })
      .catch((error) => {
        console.error('Error loading profile:', error);
        this.loading = false;
      });
  }
}
